<template>
  <svg aria-hidden="true" viewBox="0 0 1200 1200" ...attributes>
    <path
      fill="#1B2D3C"
      d="M680.0071,860.0026h-20v-40a20,20,0,0,0-40,0v40h-20a20,20,0,0,0,0,40h20v80a20,20,0,1,0,40,0v-80h20a20,20,0,0,0,0-40Z"
    ></path>
    <path
      fill="#63CC98"
      d="M220,400.0085A20.0142,20.0142,0,0,1,201.2763,372.98l60-160a20,20,0,1,1,37.4531,14.0449l-60,160A20.0073,20.0073,0,0,1,220,400.0085Z"
    ></path>
    <path
      fill="#63CC98"
      d="M520.0041,900.0085A20.0142,20.0142,0,0,1,501.28,872.98l60-160a20,20,0,1,1,37.4531,14.0449l-60,160A20.0073,20.0073,0,0,1,520.0041,900.0085Z"
    ></path>
    <path
      fill="#63CC98"
      d="M820,400.0085A20.0142,20.0142,0,0,1,801.2763,372.98l60-160a20,20,0,1,1,37.4531,14.0449l-60,160A20.0073,20.0073,0,0,1,820,400.0085Z"
    ></path>
    <path
      fill="#63CC98"
      d="M520.0014,300a20,20,0,0,1-14.1421-34.1421l60-60a20,20,0,0,1,28.2842,28.2842l-60,60A19.9369,19.9369,0,0,1,520.0014,300Z"
    ></path>
    <path
      fill="#63CC98"
      d="M220.0085,800a20,20,0,0,1-14.1421-34.1421l60-60a20,20,0,1,1,28.2842,28.2842l-60,60A19.9369,19.9369,0,0,1,220.0085,800Z"
    ></path>
    <path
      fill="#63CC98"
      d="M820,800a20,20,0,0,1-14.1421-34.1421l60-60a20,20,0,0,1,28.2842,28.2842l-60,60A19.9369,19.9369,0,0,1,820,800Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M380.0028,360.0026h-20v-40a20,20,0,0,0-40,0v40h-20a20,20,0,0,0,0,40h20v80a20,20,0,0,0,40,0v-80h20a20,20,0,1,0,0-40Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M980.0028,360.0026h-20v-40a20,20,0,0,0-40,0v40h-20a20,20,0,0,0,0,40h20v80a20,20,0,0,0,40,0v-80h20a20,20,0,0,0,0-40Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M600.0092,300h-.0063l-.0015,0a20,20,0,0,0,0,39.999v0a60,60,0,1,1-60,60V360a20,20,0,0,0-40,0v40A100,100,0,1,0,600.0092,300Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M300.0163,800h-.0078v0a20,20,0,0,0,0,39.999v0a60,60,0,1,1-60,60V860a20,20,0,0,0-40,0v40A100,100,0,1,0,300.0163,800Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M900.0078,800H900v0A20,20,0,0,0,900,840v0a60,60,0,1,1-60,60V860a20,20,0,0,0-40,0v40A100,100,0,1,0,900.0078,800Z"
    ></path>
  </svg>
</template>
